module.exports = __webpack_public_path__ + "img/2.875cd3a9.png";